export default __webpack_public_path__ + "static/media/noPictureAvailable.0215e089.png";